// extracted by mini-css-extract-plugin
module.exports = {"panel":"Overview_panel__LOzPm","element":"Overview_element__31tVm","issueStatus":"Overview_issueStatus__1wm8Q","statusStatus":"Overview_statusStatus__3dwH5"};